module.exports = __webpack_public_path__ + "static/media/add cleanliness category.04c81521.svg";